const RelatePlayAnswer = () => {
  return <div>RelatePlayAnswer</div>;
};

export default RelatePlayAnswer;
